import { WixConnect } from 'widget/player-widget/utils/wix-connect';

import styles from './icon.styl';
import fontelloIconsStyles from 'widget/player-widget/fontello/css/fontello-codes.css';


@WixConnect({ ...styles, ...fontelloIconsStyles })
export default class Icon extends React.Component {

  static propTypes = {
    name: React.PropTypes.string,
  };

  render() {
    const { name } = this.props;

    const props = _.omit(this.props, 'styles', 'styleName', 'name', 'intl', 'appSettings');

    return (
      <span styleName={`icon icon--${name}`}
            {...props} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/icon/icon.js